<template>
  <section class="user-analytics">
    <div class="box-header">
      <Search width="35%" height="40px" border-radius="3px" background-color="#FFFFFF" />
      <div class="box-right">
        <Select />
        <Button :icon="{
                  type: 'file-text',
                  size: '14px',
                  color: '#219653',
                }"
                title="Exportar"
                border-radius="3px"
                height="40px"
                border-width="1px"
                border-color="#FFF"
                margin-right="10px"
        />
        <Button :icon="{
                  type: 'filter',
                  size: '14px',
                  color: '#219653',
                }"
                border-radius="3px"
                border-width="1px"
                border-color="#FFF"
                height="40px"
        />
      </div>
    </div>

    <div class="box-details">
      <div class="empresa-details">
        <div class="resume-empresa">
          <img class="rounded-img" src="../../../assets/icons/1602006586025.png" alt="Logo da empresa">
          <p class="name-empresa">
            DPC DISTRIBUIR ATACADISTA S/A
          </p>
          <span class="tempo-cliente">Clientes desde 1999</span>
          <span class="tag-status">ONLINE</span>
        </div>

        <div class="right-box">
          <div class="basic-info">
            <feather class="basic-info__icon" type="phone" />
            <span>+55 33 9 9805-2276</span>
          </div>
          <div class="basic-info">
            <feather class="basic-info__icon" type="map" />
            <span>Travessa Coronel Santos Mestre, Centro - Caratinga MG </span>
          </div>
          <div class="basic-info">
            <feather class="basic-info__icon" type="home" />
            <span>DPC DISTRIBUIDOR ATACADISTA S/A</span>
          </div>
          <div class="basic-info">
            <feather class="basic-info__icon" type="file-text" />
            <span> 66.471.517/0001-77 </span>
          </div>
          <div class="basic-info">
            <feather class="basic-info__icon" type="smile" />
            <span> Ativo</span>
          </div>
          <div class="basic-info">
            <feather class="basic-info__icon" type="mail" />
            <span>kelvinyhenrique17@gmail.com</span>
          </div>
        </div>
      </div>
      <Dashed />
    </div>
    <div class="box-details">
      hello
    </div>
  </section>
</template>

<script>
import Search from '../../../layout/components/search/custom';
import Button from '../../../layout/components/buttons/Default';
import Select from '../../../layout/components/select/Default';
import Dashed from '../../../layout/components/charts/dashed';

export default {
	components: {
		Search,
		Select,
		Button,
		Dashed,
	},
	methods: {
		goToUser(id) {
			this.$router.push(`empresas/detalhes/${id}`);
		}
	}
};
</script>

<style scoped>

.box-details {
  margin-top: 30px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.basic-info__icon {
  width: 18px;
}
.right-box {
  padding: 10px;
}
.basic-info {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 20px;
}
.basic-info span {
  font-size: 12px;
  text-align: end;
  width: 90%;
}
.tag-status {
  padding: 3px 8px 3px 8px;
  font-weight: bold;
  color: #FFF;
  font-size: 10px;
  background-color: #219653;
  border-radius: 3px;
}
.tempo-cliente {
  font-size: 10px;
  font-weight: 500;
  margin: 15px;
}
.name-empresa {
    text-align: center;
    font-weight: bold;
    font-size: 14px;
}
.rounded-img {
  margin-bottom: 20px;
    width: 120px;
    border-radius: 50%;
}
.empresa-details {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 49%;
    background-color: #FFF;
    padding: 30px;
}
.resume-empresa {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-right: 20px;
    padding: 20px;
        border-right: 2px solid #E2EAF5;
}

.boxes-table__cards {
  margin-top: 50px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.container-select__box {
  display: flex;
  align-items: center;
  justify-content: center;
}
.right_container {
  display: flex;
}

.list-container-box {
   margin-right: 10px;
}
.filter-container__ordernation {
  margin-right: 20px;
}
.box-header {
    width: 100%;
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
}
.strong-text_green {
  font-weight: bold;
  color: #219653;
}
.user-analytics {
    width: 100%;
    display: flex;
    flex-direction: column;
    min-height: 100vh;
}
.box-right {
  display: flex;
}

.box-table-actions {
  margin-top: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

</style>
